import { SpecialWagerTypesNamesEnum } from "@tvg/ts-types/SpecialWager";
import { SpecialWagerTooltipDescription } from "../types";

export const defaultSpecialWagerTooltipDescription: SpecialWagerTooltipDescription =
  {
    [SpecialWagerTypesNamesEnum.ADVANCE]:
      "Place your bets earlier than normal (at least one day before the race) on select races. Payouts are still based on post-time odds.",
    [SpecialWagerTypesNamesEnum.FUTURE]:
      "Predict the winner of racing's biggest events before the field is set. Payouts are based on the odds at the time the pool closes and are typically larger than betting on the day of the race. Future wagers cannot be cancelled, edited, or refunded.",
    [SpecialWagerTypesNamesEnum.NON_CONSECUTIVE_PICK]:
      "Just like a typical #betTypeName#, pick the winners of #raceAmount# different races. Unlike a typical #betTypeName#, the legs are non-consecutive and can even span across multiple days or tracks."
  };
